module.exports = __webpack_public_path__ + "static/media/Icon1.7995f44a.png";